import { searchClient } from './client';

const HITS_PER_PAGE = 500;
const FACETS_PER_PAGE = 50;

const chunkArray = (array, size) => {
  return array.reduce((acc, item, index) => {
    const chunkIndex = Math.floor(index / size);
    if (!acc[chunkIndex]) {
      acc[chunkIndex] = [];
    }
    acc[chunkIndex].push(item);
    return acc;
  }, []);
};

export const getPrintFacets = async ({ facets }) => {
  let hits = [];
  const chunks = chunkArray(facets, FACETS_PER_PAGE);

  for (const chunk of chunks) {
    const response = await searchClient.search({
      requests: chunk.map((facet) => ({
        analytics: false,
        clickAnalytics: false,
        attributesToRetrieve: ['objectID', 'title'],
        indexName: window.ALGOLIA_COLLECTIONS_INDEX_NAME,
        hitsPerPage: 1,
        query: facet,
        typoTolerance: 'strict',
      })),
    });

    hits.push(
      ...response.results
        .map((result) => {
          const hit = result.hits[0];
          const query = result.query;

          return {
            id: hit?.objectID,
            facet: hit?.title,
            query: query,
          };
        })
        .filter((item) => item?.id)
    );
  }

  return hits;
};
